import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-switch',
  templateUrl: './input-switch.component.html',
  styleUrls: ['./input-switch.component.scss']
})
export class InputSwitchComponent {
   @Input() id: string;
   @Input() label: string;
   @Input() value: boolean;
   @Input() disabled: boolean;
   @Output() changeValue = new EventEmitter<boolean>();

}
